import api from "../lib/api";

export const quoteService = {
    getAvailableRequests: () =>
        api.get('/company/quotes/requests'),

    getQuoteById: (id) =>
        api.get(`/company/quotes/${id}`),

    createOffer: (quoteId, data) =>
        api.post(`/company/quotes/${quoteId}/offers`, data),

    updateOffer: (offerId, data) =>
        api.put(`/company/offers/${offerId}`, data),
};

